<h2 mat-dialog-title class="activity-obs-dialog__title">
  Editar Observaciones
</h2>

<mat-dialog-content class="activity-obs-dialog__body">
  <p class="activity-obs-dialog__label">Ingrese las observaciones de la actividad:</p>

  <textarea
    class="activity-obs-dialog__input"
    [formControl]="observacionesControl"
    rows="4"
    maxlength="500"
    placeholder="Observaciones"
    autocomplete="off"
  ></textarea>

  <p
    *ngIf="
      observacionesControl.hasError('maxlength') &&
      observacionesControl.touched
    "
    class="activity-obs-dialog__error"
  >
    Las observaciones no pueden superar los 500 caracteres.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="center" class="activity-obs-dialog__actions">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button
    mat-flat-button
    class="buttonPrimary"
    (click)="saveObservaciones()"
    [disabled]="loader"
  >
    <mat-spinner *ngIf="loader" [diameter]="18"></mat-spinner>
    <span *ngIf="!loader">Guardar</span>
  </button>
</mat-dialog-actions>
